import { render, staticRenderFns } from "./PluginEditor.vue?vue&type=template&id=bd2d5016&scoped=true&"
import script from "./PluginEditor.vue?vue&type=script&lang=js&"
export * from "./PluginEditor.vue?vue&type=script&lang=js&"
import style0 from "./PluginEditor.vue?vue&type=style&index=0&id=bd2d5016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d5016",
  null
  
)

export default component.exports